import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Log, LogTag} from '../../services/Log';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, finalize, tap} from "rxjs/operators";

@Component({
  selector: 'app-serial-port',
  template: '<div #component></div>',
  styleUrls: []
})
export class SerialPortComponent extends PlayerBase {
  serialPort;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    const logInfo = Log.getLogInfo("SerialPortComponent", "load", []);
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        const SerialPort = (<any>window).require('serialport');
        Log.d(logInfo, LogTag.PLAYER, 'serialPort ' + SerialPort);
        const Readline = SerialPort.parsers.Readline;
        const com = this.data.SerialPort[0].$.com;
        const baudRate: Number = Number(this.data.SerialPort[0].$.baudRate);
        this.serialPort = new SerialPort(com, {
          baudRate: baudRate,
        });

        const parser = new Readline();
        this.serialPort.pipe(parser);

        parser.on('data', data => {
          this.playerService.eventParams.dispatch('serial_in', data, false);
        });

        this.playerService.eventParams.getEventParam('serial_out').subscribe(value => { //???
          this.serialPort.write(value);
        });
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }
}
